module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 1104
// module chunks = 0